import { isValid } from 'date-fns/isValid'
import { parseISO } from 'date-fns/parseISO'

export const parseUnknownDate = (date: string): Date | undefined => {
  try {
    const iso = parseISO(date)
    if (isValid(iso)) return iso
  } catch {
    // Not ISO date
  }

  const fallback = new Date(date)
  if (isValid(fallback)) return fallback
}
